import { render, staticRenderFns } from "./PatServiceWorkerComponent.vue?vue&type=template&id=d0b7ff98&scoped=true"
import script from "./PatServiceWorkerComponent.vue?vue&type=script&lang=js"
export * from "./PatServiceWorkerComponent.vue?vue&type=script&lang=js"
import style0 from "./PatServiceWorkerComponent.vue?vue&type=style&index=0&id=d0b7ff98&prod&lang=css"
import style1 from "./PatServiceWorkerComponent.vue?vue&type=style&index=1&id=d0b7ff98&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0b7ff98",
  null
  
)

export default component.exports